var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('header-page',{attrs:{"name":"companies-new","title":_vm.$route.meta.title}}),_vm._v(" "),_c('company-form',{attrs:{"code-company":_vm.codeCompany,"company-id":_vm.idCompany,"code-project":_vm.codeProject}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-750e311e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/companies/page-company-new.vue
// module id = 934
// module chunks = 1